import { useCallback } from 'react';
import {
  ListingResource,
  MediaCategory,
  useListingField,
  useSyncedMediaResource,
} from '@brightmls/nextgen.lae.flc';
import { useService } from '../contexts/ServiceContext';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../flags';
import { PropertyField } from '../system/field';
import { OfficeExclusiveType } from '../components/edit/control/OfficeExclusiveDocument';

export const useOfficeExclusiveDocumentDelete = () => {
  const { hasFeature } = useFeatureFlags();
  const { deleteListingResources } = useService();

  const listingKeyField = useListingField(
    ListingResource.Property,
    PropertyField.LISTING_KEY,
    '',
  );

  const { items: localFiles, setMediaCallback: setLocalFiles } =
    useSyncedMediaResource([MediaCategory.Document, MediaCategory.FloorPlan]);

  const deleteOfficeExclusiveDocument = useCallback(async () => {
    // Check feature flag
    if (!hasFeature(FeatureFlags.NGW_OFFICE_EXCLUSIVE_DELETE_DOC)) {
      return;
    }

    // Find OE document
    const oeDocument = localFiles.find(
      (file) => file.DOCUMENT_TYPE === OfficeExclusiveType.OFFICE_EXCLUSIVE,
    );

    // If no OE document found, do nothing
    if (!oeDocument) {
      return;
    }

    const fileVWKey = oeDocument.MED_VW_KEY;
    const listingKey = listingKeyField.value;

    // Update local FLC state
    setLocalFiles((prevFiles) => {
      return prevFiles
        .filter((file) => file.MED_VW_KEY !== fileVWKey)
        .map((file, index) => ({
          ...file,
          MEDIA_DISPLAY_ORDER: index,
        }));
    });

    // Delete from backend
    try {
      await deleteListingResources(parseInt(listingKey || ''), [
        {
          type: 'Media',
          itemKey: parseInt(fileVWKey),
        },
      ]);
      console.warn(
        `Office Exclusive document deleted (MED_VW_KEY: ${fileVWKey}) - listing's attached office exclusive agreement has been removed`,
      );
    } catch (error) {
      console.error('Failed to delete Office Exclusive document:', error);
    }
  }, [
    hasFeature,
    localFiles,
    listingKeyField.value,
    setLocalFiles,
    deleteListingResources,
  ]);

  return { deleteOfficeExclusiveDocument };
};
